






























import Vue from "vue";
export default Vue.extend({
  props: ["is_selected", "count", "label"],
});
